<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <a-tabs default-active-key="1" @change="callback">
          <a-tab-pane key="1" tab="开票管理">
            <makeout-table ref="paymentDom"></makeout-table>
          </a-tab-pane>
          <a-tab-pane key="2" tab="收票管理" force-render>
            <input-table ref="collectionDom"></input-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </base-card>
  </div>
</template>

<script>
import baseCard from '@/CrComponents/Card/Card'
import inputTable from './modules/inputTable'
import makeoutTable from './modules/makeoutTable'

export default {
  name: 'InvoiceList',
  components: {
    baseCard,
    inputTable,
    makeoutTable
  },
  data () {
    return {
      cardOption: {}
    }
  },
  methods: {
    callback (key) {
      console.log(key)
    }
  }
}
</script>
